export default __webpack_public_path__ + "static/media/Tutorial Panel.c212ffb1.png";